import React from 'react';
import styles from './Wipe.module.scss';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const Wipe = ({ stage, onEnd }) => {
  return (
    <div className={styles.wipe}>
      <div
        className={classNames(
          styles.door,
          {
            [styles.open]: stage === 'open',
          },
          { [styles.close]: stage === 'close' }
        )}
        onAnimationEnd={() => {
          onEnd();
        }}
      ></div>
    </div>
  );
};

Wipe.propTypes = {
  stage: PropTypes.string,
  onEnd: PropTypes.func,
};

Wipe.defaultProps = {
  stage: null,
  onEnd: null,
};

export default Wipe;
